import SegmentsLogsPage from "./SegmentsLogsPage";

export default SegmentsLogsPage;
